import { useCallback, useState } from "react";
import useAdminLoad from "../../../hooks/useAdminLoad";
import * as crmApi from "../api/crmApi";

/** The tenant's own tags (`GET /api/crm/tags`), most used first. */
export default function useTags() {
  const [tags, setTags] = useState([]);
  const load = useCallback(async () => {
    const page = await crmApi.listTags();
    const rows = Array.isArray(page?.rows) ? page.rows : [];
    setTags(rows.map((r) => r.tag).filter(Boolean));
  }, []);
  const { loading, loadError, reload } = useAdminLoad(load);
  return { tags, loading, loadError, reload };
}
